import EventCreatorScanningLink from "./EventCreatorScanningLink"
// import PlatformFeesPayable from "./PlatformFeesPayable"

function General() {
    return (
        <div className="user-profile-main-container">

            <div className="user-profile-container">

                <EventCreatorScanningLink />

                {/* <PlatformFeesPayable /> */}

            </div>

        </div>
    )
}

export default General